<template>
  <div>
    <BlocoFiltroPesquisa
      v-if="!gerado"
      nome-fo-form="AtendimentoProfissionalForm"
      :botao-adicionar="false"
      @pesquisar="pesquisar"
    >
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <div class="form-group">
              <label for="unidade">Unidade <sup>(1)</sup></label>
              <select
                id="unidade"
                v-model="filtro.unidade"
                data-test-id="select-unidade"
                name="unidade"
                class="form-control"
                @input="v$.filtro.unidade.$touch()"
              >
                <option disabled value="">Selecione</option>
                <option
                  v-for="unidade in unidades"
                  :key="unidade._id"
                  :value="unidade.nome"
                  >{{ unidade.nome }}</option
                >
              </select>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <div
              :class="{ 'has-error': v$.filtro.dataInicio.$error }"
              class="form-group"
            >
              <label for="dataInicio">Data Início <sup>(1)</sup></label>
              <div class="input-group">
                <input
                  id="dataInicio"
                  v-model="filtro.dataInicio"
                  v-mask="'99/99/9999'"
                  data-test-id="input-datainicio"
                  name="dataInicio"
                  type="text"
                  class="form-control"
                  placeholder="DD/MM/AAAA"
                />
                <div class="input-group-addon">
                  <span
                    type="button"
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span class="fa fa-calendar"
                  /></span>
                  <span class="dropdown-menu dropdown-menu-right">
                    <li>
                      <DatePicker
                        v-model="filtro.dataInicio"
                        :today-btn="false"
                        :clear-btn="false"
                        :format="'dd/MM/yyyy'"
                        :close-on-selected="true"
                        :date-parser="dataParser"
                        class="date-picker"
                      />
                    </li>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <div
              :class="{ 'has-error': v$.filtro.dataInicio.$error }"
              class="form-group"
            >
              <label for="dataFim">Data Fim <sup>(1)</sup></label>
              <div class="input-group">
                <input
                  id="dataFim"
                  v-model="filtro.dataFim"
                  v-mask="'99/99/9999'"
                  data-test-id="input-datafim"
                  name="dataFim"
                  type="text"
                  class="form-control"
                  placeholder="DD/MM/AAAA"
                />
                <div class="input-group-addon">
                  <span
                    type="button"
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span class="fa fa-calendar" />
                  </span>
                  <span class="dropdown-menu dropdown-menu-right">
                    <li>
                      <DatePicker
                        v-model="filtro.dataFim"
                        :today-btn="false"
                        :clear-btn="false"
                        :format="'dd/MM/yyyy'"
                        :close-on-selected="true"
                        :date-parser="dataParser"
                        class="date-picker"
                      />
                    </li>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <div class="form-group">
              <label for="profissional">Profissional</label>
              <BuscarSelecionar
                :lista="profissionais"
                :selecionado="filtro.profissional"
                :exibir="['nome']"
                :minimo="0"
                :ativo="profissionalAtivo"
                :exibir-chave="false"
                @selecionar="selecionarProfissional"
                @limpar="limparProfissional"
                @recuperar="recuperarProfissionais"
              />
            </div>
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <div v-if="!gerado">
      <div
        v-if="atendimentoPorProfissional.length > 0"
        class="row"
        style="margin-top: 2rem"
      >
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="pull-right">
            <button type="button" class="btn btn-info" @click="gerado = true"
              >Gerar relatório</button
            >
            <button type="button" class="btn btn-success" @click="marcarTodos()"
              >Marcar todos</button
            >
            <button
              type="button"
              class="btn btn-danger"
              @click="desmarcarTodos()"
              >Desmarcar todos</button
            >
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div
            v-for="(
              atendimentoProfissional, index
            ) in atendimentoPorProfissional"
            id="panels"
            :key="atendimentoProfissional.Profissional"
            class="panel-group"
            role="tablist"
            aria-multiselectable="true"
          >
            <div class="panel panel-primary">
              <div
                :id="'atendimentoItemTitulo' + index"
                class="panel-heading"
                role="tab"
              >
                <input
                  v-model="atendimentoPorProfissionalSelecionado"
                  :value="atendimentoProfissional"
                  type="checkbox"
                />
                <a
                  :data-target="'#atendimentoItemCorpo' + index"
                  :aria-controls="'atendimentoItemCorpo' + index"
                  role="button"
                  data-toggle="collapse"
                  data-parent="#panels"
                  aria-expanded="false"
                >
                  <span class="nome_profissional">{{
                    atendimentoProfissional.Profissional
                  }}</span>
                  <span class="resumo_profissional pull-right">
                    <strong>Quantidade: </strong>
                    {{ atendimentoProfissional.TotalQuantidade }}</span
                  >
                </a>
              </div>
              <div
                :id="'atendimentoItemCorpo' + index"
                :aria-labelledby="'atendimentoItemTitulo' + index"
                class="panel-collapse collapse"
                role="tabpanel"
              >
                <table class="table table-striped table-hover table-bordered">
                  <thead>
                    <tr style="background-color: #008080">
                      <td class="text-center tabela-head">Situação</td>
                      <td class="text-right tabela-head">Quantidade</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="atendimento in atendimentoProfissional.Atendimentos"
                      :key="atendimento.Status"
                    >
                      <td class="text-center">{{
                        converteStatus(atendimento.Status)
                      }}</td>
                      <td class="text-right">{{ atendimento.Quantidade }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="gerado">
      <div class="row pull-right">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <button type="button" class="btn btn-danger" @click="gerado = false"
            >Voltar</button
          >
        </div>
      </div>
      <div v-if="filtro && atendimentoPorProfissional">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <h1>Relatório de Atendimentos por Profissional</h1>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <td>Unidade</td>
                  <td>Data Início</td>
                  <td>Data Fim</td>
                  <td>Profissional</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ filtro.unidade }}</td>
                  <td>{{ filtro.dataInicio }}</td>
                  <td>{{ filtro.dataFim }}</td>
                  <td>{{
                    filtro.profissional.nome
                      ? filtro.profissional.nome
                      : 'Todos'
                  }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          v-for="atendimentoProfissional in atendimentoPorProfissional"
          :key="atendimentoProfissional.Profissional"
        >
          <br />
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h3>{{ atendimentoProfissional.Profissional }}</h3>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Situação</th>
                    <th class="text-right">Quantidade</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="atendimento in atendimentoProfissional.Atendimentos"
                    :key="atendimento.Status"
                  >
                    <td>{{ converteStatus(atendimento.Status) }}</td>
                    <td class="text-right">{{ atendimento.Quantidade }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td><strong>TOTAL</strong></td>
                    <td class="text-right"
                      ><strong>{{
                        atendimentoProfissional.TotalQuantidade
                      }}</strong></td
                    >
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import AwesomeMask from 'awesome-mask'
import moment from 'moment'
import { DatePicker } from 'uiv'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import BuscarSelecionar from '@/componentes/formulario/BuscarSelecionar'
import { useMenu } from '@/composables/useMenu'
import STATUS_AGENDAMENTO from '@/constantes/dominio/STATUS_AGENDAMENTO'
import AgendaServico from '@/servicos/AgendaServico'
import MensagemServico from '@/servicos/MensagemServico'
import ProfissionalServico from '@/servicos/ProfissionalServico'
import UnidadeServico from '@/servicos/UnidadeServico'

const unidadeServico = new UnidadeServico()
const profissionalServico = new ProfissionalServico()
const mensagemServico = new MensagemServico()
const agendaServico = new AgendaServico()

export default {
  components: { DatePicker, BlocoFiltroPesquisa, BuscarSelecionar },
  directives: { mask: AwesomeMask },
  setup() {
    useMenu(28)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      atendimentoPorProfissional: [],
      atendimentoPorProfissionalSelecionado: [],
      unidades: [],
      profissionais: [],
      gerado: false,
      filtro: {
        unidade: '',
        profissional: {},
        dataInicio: moment().startOf('month').format('DD/MM/YYYY'),
        dataFim: moment().endOf('month').format('DD/MM/YYYY'),
      },
    }
  },
  created() {
    this.recuperarUnidades()
  },
  validations: {
    filtro: {
      unidade: { required },
      dataInicio: { required },
      dataFim: { required },
    },
  },
  methods: {
    converteStatus(valor) {
      const statusEncontrado = STATUS_AGENDAMENTO.valores.find(
        (s) => s.id === valor
      )
      return statusEncontrado ? statusEncontrado.descricao : ''
    },
    pesquisar() {
      this.v$.$touch()

      if (this.v$.filtro.$invalid) {
        mensagemServico.alerta('Preencha os campos corretamente.')
      } else {
        agendaServico
          .relatorioAtendimentoProfissional({
            unidade: this.filtro.unidade,
            dataInicio: moment(this.filtro.dataInicio, 'DD/MM/YYYY').format(
              'YYYY-MM-DD'
            ),
            dataFim: moment(this.filtro.dataFim, 'DD/MM/YYYY').format(
              'YYYY-MM-DD'
            ),
            idProfissional: this.filtro.profissional._id,
          })
          .then((result) => {
            this.atendimentoPorProfissional = result.linhasRelatorio
            this.atendimentoPorProfissionalSelecionado = result.linhasRelatorio
          })
      }
    },
    limparFiltro() {
      this.filtro.unidade = ''
      this.filtro.profissional = {}
      this.filtro.dataInicio = moment().startOf('month').format('DD/MM/YYYY')
      this.filtro.dataFim = moment().endOf('month').format('DD/MM/YYYY')
    },
    recuperarUnidades() {
      unidadeServico.recuperarTodos().then((result) => {
        this.unidades = result.unidades
      })
    },
    selecionarProfissional(profissional) {
      this.filtro.profissional = {
        _id: profissional._id,
        nome: profissional.nome,
      }
    },
    limparProfissional() {
      this.filtro.profissional = {}
    },
    recuperarProfissionais(filtro) {
      const data = {
        nome: filtro.palavra,
        skip: (filtro.pagina - 1) * filtro.limite,
        limit: filtro.limite,
        orderBy: filtro.chave,
      }

      profissionalServico.recuperarTodos(data).then((result) => {
        this.profissionais = result.profissionais

        this.profissionais.forEach((p) => {
          if (p.bloqueado) {
            p.nome = `${p.nome} (${p.motivo})`
          }
        })
      })
    },
    profissionalAtivo(item) {
      return !item.bloqueado
    },
    dataParser(value) {
      return moment(value, 'DD/MM/YYYY').toDate().getTime()
    },
    marcarTodos() {
      this.atendimentoPorProfissionalSelecionado = []
      this.atendimentoPorProfissional.forEach((a) => {
        this.atendimentoPorProfissionalSelecionado.push(a)
      })
    },
    desmarcarTodos() {
      this.atendimentoPorProfissionalSelecionado = []
    },
  },
}
</script>

<style scoped>
.nome_profissional {
  margin: 0 15px;
  font-size: 16px;
  color: #ecf0f1;
}

.resumo_profissional {
  margin: 0 5px;
  font-size: 14px;
  color: #ecf0f1;
}

.tabela-head {
  font-weight: 600;
  color: #ecf0f1;
}
</style>
